import React, { Fragment, useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DropdownItem, Badge } from "reactstrap";
import ActionOptions from "../../Common/Component/ActionOptions";
import StatusBadge from "../../Common/Component/StatusBadge";
import { Breadcrumbs, Spinner } from "../../../AbstractElements";
import DataTable from "react-data-table-component";
import CustomizerContext from "../../../_helper/Customizer";
import { DriverTypeColumns } from "../../../Data/Driver/DriverType";
import SharedDataContext from "../../../_helper/SharedData";
import { deleteDriverType, getDriverTypeAllCity, getDriverTypeTable, getDriverTypeWalletAllSearch } from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
import DriverSchemeEdit from "../EditForms/DriverSchemeEdit";
import DriverSchemeMinimumEdit from "../EditForms/DriverSchemeMinimumEdit";
import TariffModal from "../../../CommonElements/TariffModal/TariffModal";
import SearchTable from "../../Common/Component/SearchTable";
import FilterTable from "../../Common/Component/FilterTable";
import TariffSearchFilter from "../../Common/Component/TariffSearchFilter";
import CustomSearchFilter from "../../Common/Component/CustomSearchFilter";
import CustomTabs from "../../../CommonElements/CommonTabs/CustomTabs";
import DriverSchemeForm from "../Forms/DriverSchemeForm";
import UnifiedDriverSchemeForm from "../Forms/UnifiedDriverSchemeForm";
import { DriverDeductionForm } from "../Forms/DriverDeductionForm";
import { DriverSchemeDeductionForm } from "../Forms/DriverSchemeDeductionForm";
import WalletMinBal from "../../WalletBalance/Forms/WalletMinBal";
import { Plus, Search } from "react-feather";
import searchIcon from "../../../assets/images/tarrifManagement/search.svg";
import moment from "moment";
// import { Breadcrumbs } from "../../../AbstractElements";


function DriverTypeTable({ }) {
  const { globalCityField } = useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const { mix_background_layout } = useContext(CustomizerContext);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isModal,setIsModal] = useState(false)
  const [editModal,setEditModal] = useState(false)
  const [isSearch, setIsSearch] = useState(true);
  const [editId,setEditId] = useState(null)
  const [minimumEdit, setminimumEdit] = useState({})
  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [isAddModal, setIsAddModal] = useState(false);


  const toggleModal=(editId)=>{
    setEditId(editId)
    setIsModal(!isModal)
  }
  const closeModal = ()=>{
    setIsModal(!isModal)
  }
  // -------------minimum edit table
  const toggleEditModal=(id,driverSchemeName)=>{
    setminimumEdit({id,driverSchemeName})
    setEditModal(!editModal)
  }
  const closeEditModal = ()=>{
    setEditModal(!editModal)
  }

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const disableLoaders = () => {
    setLoader(false);
  };

  const triggerRefresh = () => {
    setIsRefresh(!isRefresh);
  };

  useEffect(() => {
    fetchTableData();
  }, [globalCityField.value, pagination, rowsPerPage, isRefresh,searchData]);

  const fetchTableData = () => {
    const serviceCityId = globalCityField.value?globalCityField.value.id:0;
    if(searchData && filterType == "search"){
      let obj = {
        key:searchData,
        serviceCityId: serviceCityId,
      };
      setLoader(true);
      getDriverTypeWalletAllSearch(obj).then((resp)=>{
        setPaginationTotalRows(resp.data.count)
        setTableData(resp.data.searchResponse)
        setLoader(false)
      }).catch((err)=>{
        disableLoaders();
        showAlert("error","Can't able to Search Data")
      })
    }else{
      setLoader(true);
    getDriverTypeTable(serviceCityId).then((resp)=>{
        setPaginationTotalRows(resp.data.count)
        setTableData(resp.data.searchResponse)
        setLoader(false)
    }).catch((err)=>{
        disableLoaders();
      showAlert("error","Can't able to Fetch Data")
      })
      //  }else{
      //   getDriverTypeAllCity(serviceCityId).then((resp)=>{
      //     setPaginationTotalRows(resp.data.count)
      //     setTableData(resp.data.searchResponse)
      //     setLoader(false)
      //   }).catch((err)=>{
      //     disableLoaders();
      //     showAlert("error","Can't able to Fetch Data")
      //   })
      //  }
    }
  };



  const isDeleteUpdate=(driverTypeId,isDelete)=>{
    let obj = {
        driverTypeId:driverTypeId,
        isDeleted:isDelete
    }

    deleteDriverType(obj).then((resp)=>{
      showAlert("success","Driver Type deleted")
      triggerRefresh()
    }).catch((err)=>{
      showAlert("error",err.message)
    })

  }

  const processData = tableData.map((element, index) => {
    return {
      name: element.driverSchemeName ? element.driverSchemeName : "",
      subscription: element.isSubscription ? "True" : "False",
      serviceCity: element.serviceCityName ? element.serviceCityName : "",
      applicableFrom: element.applicableFrom ?moment(new Date( element.applicableFrom)).format("MMM DD YY HH:mm" ) : "-",
      applicableTo: element.applicableTo ?moment(new Date( element.applicableTo)).format("MMM DD YY HH:mm" ) : "-",
      minimumBalance: element.minimumBalance
        ? element.minimumBalance
        : "-",
      status: element.isDeleted ? "Inactive" : "Active",
      isDeleted: element.isDeleted,
      driverTypeId: element.driverTypeId,
      action: (
        <ActionOptions key={index}>
          <Fragment>
            <DropdownItem
              className="border-0"
              onClick={() => {
                toggleModal(element.driverTypeId)
              }}
            >
             <i className="fa fa-pencil" ></i>{" "}
              {"Edit"}
            </DropdownItem>
            <DropdownItem
              className="border-0"
              onClick={() => {
                isDeleteUpdate(element.driverTypeId, !element.isDeleted)
              }}
            >
              <i className="fa fa-trash-o"></i>{" "}
              {element.isDeleted ? "Recover" : "Delete"}
            </DropdownItem>
          </Fragment> 
        </ActionOptions>
      )
    };
  });

  const customStyles = {
    table: {
      style: {
        backgroundColor: "transparent",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#E1F4E4",
        minHeight: "50px",
        borderBottomWidth: "0px",
      },
    },
    headCells: {
      style: {
        color: "#626262",
        fontWeight: "700",
        fontSize: "16px",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#313131",
      },
    },
    rows: {
      style: {
        "&:hover": {
          backgroundColor: "#EBEBEB !important",
          cursor: "pointer",
        },
        borderBottom: "none !important",
      },
    },
  };

  const columns = DriverTypeColumns.map(col => {
    if (col.name === "Name") {
      return {
        ...col,
        cell: (row) => (
          <Link 
            to={`${process.env.PUBLIC_URL}/driver/driver-scheme-details/${row.driverTypeId}`}
            style={{ color: "#39B54A", fontWeight: "600", fontSize: "15px", textDecoration: "none" }}
          >
            {row.name}
          </Link>
        )
      };
    }
    if (col.name === "Status") {
      return {
        ...col,
        cell: (row) => (
          <StatusBadge 
            isDeleted={row.isDeleted} 
          />
        )
      };
    }
    return col;
  });

  return (
    <div className="driver-type-table">
      <Breadcrumbs
        parent="Configuration"
        subParent="Packages"
        mainTitle="Packages"
        style={{ padding: "0px" }}
        span3={
          <div className="d-flex align-items-center justify-content-end gap-3" style={{ width: "100%" }}>
            <div style={{ minWidth: "250px" }}>
              <CustomSearchFilter
                searchData={searchData}
                setSearchData={setSearchData}
                setFilterData={setFilterData}
                setFilterType={setFilterType}
                placeholder="Search Driver Scheme"
              />
            </div>
            <div
              style={{
                color: "rgba(57, 181, 74, 1)",
                border: "1px solid rgba(57, 181, 74, 1)",
                borderRadius: "10px",
                backgroundColor: "rgba(225, 244, 228, 1)",
                height: "40px", // Using px for more reliable sizing
                minWidth: "140px",
                fontSize: "15px",
                padding: "0 20px",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                cursor: "pointer",
                fontWeight: "600",
                whiteSpace: "nowrap"
              }}
              onClick={() => setIsAddModal(true)}
            >
              <Plus size={18} />
              Add Scheme
            </div>
          </div>
        }
      />
      <div className="table-responsive">
        <DataTable
          columns={columns}
          data={processData}
          customStyles={customStyles}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          // paginationPerPage={paginationPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          paginationServer
          progressPending={loader}
          triggerRefresh={triggerRefresh}
          progressComponent={
            <div className="loader-box" style={{ height: "57vh" }}>
              <Spinner
                attrSpinner={{
                  className: "loader-3",
                  style: {
                    width: "30px",
                    height: "30px",
                    borderColor: "#39B54A",
                    borderBottomColor: "transparent",
                  },
                }}
              />
            </div>
          }
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
      {/* <DriverSchemeEdit closeModal={closeModal} editId={editId} isModal={isModal} triggerRefresh={triggerRefresh} /> */}

      <TariffModal
        isOpen={isAddModal}
        size="lg"
        centered
        toggler={() => setIsAddModal(!isAddModal)}
        title={"Add Driver Scheme"}
      >
        <UnifiedDriverSchemeForm
          setIsModal={setIsAddModal}
          triggerRefresh={triggerRefresh}
        />
      </TariffModal>

      <TariffModal
        isOpen={isModal}
        size="lg"
        centered
        toggler={closeModal}
        title={"Edit Driver Scheme"}
      >
        <UnifiedDriverSchemeForm
          editId={editId}
          setIsModal={setIsModal}
          triggerRefresh={triggerRefresh}
        />
      </TariffModal>
    </div>
  );
}

export default DriverTypeTable;
